import { render, staticRenderFns } from "./RegistrationStep1.vue?vue&type=template&id=24bdad3f"
import script from "./RegistrationStep1.vue?vue&type=script&lang=js"
export * from "./RegistrationStep1.vue?vue&type=script&lang=js"
import style0 from "./RegistrationStep1.vue?vue&type=style&index=0&id=24bdad3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports